import styled from "styled-components"
export const AuthFormContainer = styled.div`
  width: 52em;
  margin: 0 auto;
  padding: 4rem 2rem;
`
